import { useState } from 'react'
import { NavLink, Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../auth/AuthProvider'
import { ThemeToggle } from './ThemeToggle'
import { LangSwitch } from './LangSwitch'

function BrandMark() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <defs>
        <linearGradient id="pd-g" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#3b82f6" />
          <stop offset="1" stopColor="#6366f1" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="14" fill="url(#pd-g)" />
      <path d="M22 12h14l12 12v26a4 4 0 0 1-4 4H22a4 4 0 0 1-4-4V16a4 4 0 0 1 4-4z" fill="#fff" opacity="0.96" />
      <path d="M36 12v12h12z" fill="#dbeafe" />
      <path d="M33 24l7 9h-4.4v9h-5.2v-9H26z" fill="#2563eb" />
    </svg>
  )
}

function UserChip() {
  const { user, logout } = useAuth()
  const { t } = useTranslation()
  if (!user) return null
  const initial = (user.username || '?').trim().charAt(0).toUpperCase()
  return (
    <>
      <div className="user-chip">
        {user.avatar ? (
          <img className="avatar" src={user.avatar} alt={user.username} loading="lazy" />
        ) : (
          <span className="avatar-fallback" aria-hidden="true">{initial}</span>
        )}
        <span className="user-name">{user.username}</span>
      </div>
      <button type="button" className="btn ghost sm" onClick={() => void logout()}>
        {t('auth.logout')}
      </button>
    </>
  )
}

export function Header() {
  const { t } = useTranslation()
  const { user, loading, login } = useAuth()
  const [menuOpen, setMenuOpen] = useState(false)

  const navLinks = (
    <>
      <NavLink to="/" end onClick={() => setMenuOpen(false)}>
        {t('nav.home')}
      </NavLink>
      <NavLink to="/records" onClick={() => setMenuOpen(false)}>
        {t('nav.records')}
      </NavLink>
    </>
  )

  return (
    <header className="site-header">
      <div className="container header-inner">
        <Link to="/" className="brand" aria-label="PageDrop">
          <BrandMark />
          <span>PageDrop</span>
        </Link>
        <nav className="main-nav" aria-label={t('nav.home')}>
          {navLinks}
        </nav>
        <div className="header-actions">
          <LangSwitch />
          <ThemeToggle />
          {loading ? null : user ? (
            <UserChip />
          ) : (
            <button type="button" className="btn primary sm" onClick={login}>
              {t('auth.login')}
            </button>
          )}
        </div>
        <button
          type="button"
          className="icon-btn menu-toggle"
          aria-expanded={menuOpen}
          aria-label="Menu"
          onClick={() => setMenuOpen((v) => !v)}
        >
          {menuOpen ? '✕' : '☰'}
        </button>
      </div>
      {menuOpen && (
        <div className="mobile-nav container">
          <nav aria-label={t('nav.home')}>{navLinks}</nav>
          <div className="mobile-actions">
            {user ? (
              <UserChip />
            ) : (
              <button type="button" className="btn primary sm" onClick={login}>
                {t('auth.login')}
              </button>
            )}
          </div>
        </div>
      )}
    </header>
  )
}
